import { Badge } from '@/components/ui/badge'

interface LinkedContentProps {
  territory: string
  brand: string
}

export function LinkedContent({ territory, brand }: LinkedContentProps) {
  return (
    <div className="space-y-2">
      <div className="flex gap-2 items-center">
        <span className="text-sm font-medium text-primary">Conteúdo vinculado a:</span>
        <Badge variant="outline">{territory}</Badge>
        <Badge variant="outline">{brand}</Badge>
      </div>
    </div>
  )
}
